// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Divider, Button, Grid, Text, Flex, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { NavLink, Link } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { parseFullDate } from 'services/Utils';
import placeholderGiveaways from 'assets/img/placeholder-giveaways.jpg';

// Components
import Countdown from 'components/Timers/Countdown';

const Giveaways = ({setFamousGiveawayIsHidden, userData}) => {	
	const colorDate = useColorModeValue('#262D47', '#9FABCB');
	const boxShadow = useColorModeValue('unset', '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)');
 
	const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

	const [data, setDate] = useState([]);
	const [active, setActive] = useState(0);
	const [activeGallery, setActiveGallery] = useState(0);

    useQuery({
        queryKey: ['giveaways'],
        queryFn: async () => {
            const response = await apiService.getGiveaways({ limit: 1, offset: 0, status: 'active' });
            setDate(response.data);
            if(response?.data?.length !== 0){
                setFamousGiveawayIsHidden(false);
            }
            return true;
        },
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (!data?.length) { return; }

        const interval = setInterval(() => {
            setActiveGallery((prev) => (prev + 1) % data.length); 
        }, 5000);

        return () => clearInterval(interval); 
    }, [data]);

    return (
    	<>
    	{ data?.length > 0 && (
	        <Grid templateColumns={{ sm: '1fr', lg: '1fr 1fr' }} gap="70px" rowGap="24px" templateRows='1fr'>
	        	<Box
	        		borderRadius="16px"
	        		minW={{sm: '100%'}}
	        		h={{base: '224px', sm: '342px'}}
					border="1px solid #2ABDFD"
					overflow="hidden"
					display="flex"
				    alignItems="center"
				    justifyContent="center"
				    position="relative"
					boxShadow={boxShadow}>
	        		<Image src={ data?.gallery ? data[activeGallery]?.image : data[active]?.image ? data[active]?.image : placeholderGiveaways } objectFit="cover" w="100%" h="100%" />
	        		<Countdown endDate={data[active]?.endDate} declareDate={data[active]?.declareDate} fontSize={{base: '20px', sm: '32px'}} />
	        		<Flex position="absolute" bottom="8px" w="100%" justify="center" gap="4px">
					    { data?.gallery?.map((_, index) => (
					        <Box
					            key={index}
					            bg={index === active ? '#099BFF' : 'rgba(214, 223, 240, 0.50)'}
					            borderRadius="full"
					            w="8px"
					            h="8px"
					            transition="background-color 0.3s ease"
					        />
					    ))}
					</Flex>
	        	</Box>

	        	<Box alignSelf="center">
	        		<Text variant="header" fontSize={{base: '36px', sm: '48px'}} textTransform="unset" mt="-5px">{data[active]?.title}</Text>
	        		<Text fontSize={{base: '18px', sm: '24px'}} fontWeight="500" color={colorDate} mt="4px">{parseFullDate(data[active]?.endDate)}</Text>
	        		<Text mt={{base: '8px', sm: '16px'}}>{data[active]?.description}</Text>

	        		<a href={ userData ? data[active]?.promotionLink : data[active]?.publicPromotionLink ?? `/giveaways/${data[active]?.id}`}>
	                    <Button variant={ isDark ? 'button-lg-g' : 'button-lg'} w={{base: '100%', sm: '280px'}} mt={{base: '24px', sm: '40px'}} >Enter Now</Button>
	                </a>
	        	</Box>
	        </Grid>
	    )}
	    </>
    );
};


export default Giveaways;